var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionVideo',{attrs:{"id":"SectionSmartSave","content":_vm.$t('paragraph'),"cta":_vm.$t('cta'),"title":_vm.$t('title'),"videoSrc":"https://www.youtube.com/embed/8A-Yp2B55Ws"}})
}
var staticRenderFns = []

export { render, staticRenderFns }